import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import useFetch from '../../../hooks/useFetch';
import { fetchUserTeams, fetchEloTeams } from '../../../api/userTeams';
import { filterTempTeams } from '../../../helpers/teamHelpers';

const LeaderboardCard = () => {
    const { data: rawTeams } = useFetch(fetchUserTeams, []);
    const { data: rawLeaderboard, loading } = useFetch(fetchEloTeams, []);

    const teams = useMemo(() => filterTempTeams(rawTeams || []), [rawTeams]);
    const leaderboard = useMemo(() => {
        const sorted = (rawLeaderboard || []).sort((a, b) => (b.elo || 0) - (a.elo || 0));
        return filterTempTeams(sorted);
    }, [rawLeaderboard]);

    const bestTeam = teams.length
        ? teams.reduce((best, t) => ((t.score || 0) > (best.score || 0) ? t : best), teams[0])
        : null;

    const userRank = bestTeam
        ? leaderboard.findIndex(t => String(t.userTeamID) === String(bestTeam.userTeamID)) + 1
        : 0;

    const leaderboardPeek = useMemo(() => {
        if (!userRank) return [];
        const idx = userRank - 1;
        const start = Math.max(0, idx - 2);
        const end = Math.min(leaderboard.length, idx + 3);
        return leaderboard.slice(start, end).map((t, i) => ({
            ...t,
            rank: start + i + 1,
            isUser: String(t.userTeamID) === String(bestTeam?.userTeamID),
        }));
    }, [userRank, leaderboard, bestTeam?.userTeamID]);

    if (loading || leaderboardPeek.length === 0) return null;

    return (
        <div className="priority-card">
            <div className="priority-card-header">
                <h3>Leaderboard</h3>
                <Link to="/leaderboard">View Full</Link>
            </div>
            {leaderboardPeek.map(t => (
                <div key={t.userTeamID} className={`dash-leaderboard-row${t.isUser ? ' dash-leaderboard-you' : ''}`}>
                    <span className="dash-lb-rank">#{t.rank}</span>
                    <span className="dash-lb-name">{t.name || 'Unnamed'}</span>
                    <span className="dash-lb-elo">{t.elo || '—'}</span>
                </div>
            ))}
        </div>
    );
};

export default LeaderboardCard;
